import collectiveApi from 'modules/common/collectiveApi';

const fetchPaymentReceipt = async ({ isEmployeeView, uuid }: { isEmployeeView?: boolean; uuid: string }) => {
    const endpoint = isEmployeeView ? 'ms-member-documents' : 'member-documents';
    const { data } = await collectiveApi.get(`/documents/${endpoint}/${uuid}/download_url/`);

    return data;
};

export default fetchPaymentReceipt;
